export const locales = {
  en: {
    label: "English",
    dayjs: () => import("dayjs/locale/en"),
    flatpickr: null,
    i18n: () => import("./locales/en/translations.json"),
    flag: "united-kingdom",
  },
  hi: {
    label: "Hindi",
    dayjs: () => import("dayjs/locale/hi"),
    flatpickr: null,
    i18n: () => import("./locales/hi/translations.json"),
    flag: "india",
  },
  mr: {
    label: "Marathi",
    dayjs: () => import("dayjs/locale/mr"),
    flatpickr: null,
    i18n: () => import("./locales/mr/translations.json"),
    flag: "india",
  },
  gom: {
    label: "Konkani",
    dayjs: () => import("dayjs/locale/en"),
    flatpickr: null,
    i18n: () => import("./locales/gom/translations.json"),
    flag: "india",
  },
  ar: {
    label: "Arabic",
    dayjs: () => import("dayjs/locale/ar"),
    flatpickr: () =>
      import("flatpickr/dist/l10n/ar").then((module) => module.Arabic),
    i18n: () => import("./locales/ar/translations.json"),
    flag: "saudi",
  },
};

export const supportedLanguages = Object.keys(locales);

export type LocaleCode = keyof typeof locales;

export type Dir = "ltr" | "rtl";
